import { render } from "./MassimarioSearchParams.vue?vue&type=template&id=c5df5500"
import script from "./MassimarioSearchParams.vue?vue&type=script&lang=ts"
export * from "./MassimarioSearchParams.vue?vue&type=script&lang=ts"
script.render = render

export default script